/**-----------------------------------------------------------------------------------------
* Copyright © 2023 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the package root for more information
*-------------------------------------------------------------------------------------------*/
"use client";
import * as s from "react";
import * as tt from "react-dom";
import n from "prop-types";
import { ZIndexContext as k, dispatchEvent as P, validatePackage as D, classNames as m } from "@progress/kendo-react-common";
import { Popup as et } from "@progress/kendo-react-popup";
const p = 10, u = 10, ot = (o, t, e, i, r) => {
  switch (r) {
    case "bottom":
      return i === "pointer" ? o - t / 2 : e.left - t / 2 + e.width / 2;
    case "left":
      return i === "pointer" ? o - t - p : e.left - t - p;
    case "right":
      return i === "pointer" ? o + p : e.right + p;
    case "top":
      return i === "pointer" ? o - t / 2 : e.left - t / 2 + e.width / 2;
    default:
      return i === "pointer" ? o < window.screen.availWidth / 2 ? o - p : o - t + p : o < window.screen.availWidth / 2 ? e.left : e.right - t;
  }
}, nt = (o, t, e, i, r) => {
  switch (r) {
    case "bottom":
      return i === "pointer" ? o + u : t.bottom + u;
    case "left":
      return i === "pointer" ? o - e / 2 : t.top - e / 2 + t.height / 2;
    case "right":
      return i === "pointer" ? o - e / 2 : t.top - e / 2 + t.height / 2;
    case "top":
      return i === "pointer" ? o - e - u : t.top - e - u;
    default:
      return i === "pointer" ? o < window.innerHeight / 2 ? o + p : o - e - p : o < window.innerHeight / 2 ? t.bottom + u : t.top - e - u;
  }
}, it = (o) => o !== null ? o.getBoundingClientRect() : document.body.getBoundingClientRect(), st = [
  "k-tooltip-content",
  "k-animation-container",
  "k-tooltip",
  "k-tooltip-title",
  "k-tooltip k-tooltip-closable",
  "k-icon k-i-close"
], N = (o) => {
  if (o === null)
    return !1;
  let t = o;
  for (; t; ) {
    if (t !== null && t.classList && t.classList.contains("k-tooltip"))
      return !0;
    t.parentNode !== null ? t = t.parentNode : t = !1;
  }
  return st.filter((e) => e === o.className).length > 0;
}, R = {
  name: "@progress/kendo-react-tooltip",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1702645195,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/components/my-license/"
}, rt = 100, A = class extends s.PureComponent {
  constructor(o) {
    super(o), this.context = 0, this.state = {
      targetElement: null,
      open: !1,
      title: ""
    }, this.top = 0, this.left = 0, this.willOpen = !1, this.handleMouseOut = (t) => {
      const { targetElement: e } = this.state, i = e ? e.ownerDocument : document;
      let r = i && i.elementFromPoint(t.clientX, t.clientY);
      N(r) || this.props.open || (clearInterval(this.updateIntervalId), this.willOpen = !1, this.onClose(t));
    }, this.handleMouseOver = (t) => {
      const e = t.target;
      !this.isVisible(e) || N(e) || e === this.state.targetElement || this.showToolTip(t);
    }, this.handleBodyMousemove = (t) => {
      this.top = t.clientY, this.left = t.clientX;
    }, this.onClose = (t) => {
      P(this.props.onClose, t, this, void 0), this.setState({ targetElement: null, open: !1, title: "" });
    }, this.setUpdateInterval = () => {
      this.props.updateInterval && (this.updateIntervalId = setInterval(
        this.onIntervalUpdate,
        this.props.updateInterval
      ));
    }, this.onIntervalUpdate = () => {
      const t = this.state.targetElement;
      t && (t.parentElement === null ? this.onClose({ target: t }) : this.showToolTip({ target: t }));
    }, this.position = (t) => {
      let e = it(this.state.targetElement);
      const i = ot(
        this.left,
        t.offsetWidth,
        e,
        this.props.anchorElement,
        this.props.position
      ), r = nt(
        this.top,
        e,
        t.offsetHeight,
        this.props.anchorElement,
        this.props.position
      );
      return { left: i, top: r };
    }, this.getTitle = (t) => {
      for (; t; ) {
        if (t.getAttribute("title") !== null || t.titleExpando)
          return { title: t.getAttribute("title") || t.titleExpando, element: t };
        t = this.props.parentTitle && t.parentElement || null;
      }
      return { title: "", element: t };
    }, this.calloutClassName = () => {
      switch (this.props.position) {
        case "bottom":
          return "k-callout k-callout-n";
        case "left":
          return "k-callout k-callout-e";
        case "right":
          return "k-callout k-callout-w";
        case "top":
          return "k-callout k-callout-s";
        default:
          return this.top < window.innerHeight / 2 ? "k-callout k-callout-n" : "k-callout k-callout-s";
      }
    }, this.getCurrentZIndex = () => this.context ? this.context : rt, D(R);
  }
  /**
   * @hidden
   */
  componentDidMount() {
    document && document.body.addEventListener("mousemove", this.handleBodyMousemove);
  }
  /**
   * @hidden
   */
  componentWillUnmount() {
    clearTimeout(this.openTimeoutId), clearInterval(this.updateIntervalId), document && document.body.removeEventListener("mousemove", this.handleBodyMousemove);
  }
  /**
   * @hidden
   */
  componentDidUpdate() {
    this.props.open && this.props.targetElement && this.showToolTip({ target: this.props.targetElement });
  }
  /**
   * @hidden
   */
  render() {
    if (this.props.children) {
      const { children: e, ...i } = this.props;
      let r = null;
      return /* @__PURE__ */ s.createElement(
        "div",
        {
          onMouseOver: (a) => {
            r && r.handleMouseOver(a);
          },
          onMouseOut: (a) => {
            r && r.handleMouseOut(a);
          }
        },
        /* @__PURE__ */ s.createElement(A, { ref: (a) => r = a, ...i }),
        e
      );
    }
    if (this.props.open === !1)
      return null;
    const { targetElement: o } = this.state, t = this.getCurrentZIndex();
    return o && this.state.title && o.ownerDocument && tt.createPortal(
      /* @__PURE__ */ s.createElement(
        "div",
        {
          ref: (e) => {
            if (!e)
              return;
            let i;
            if (this.props.onPosition) {
              const r = {
                element: e,
                targetElement: this.state.targetElement,
                mouseTop: this.top,
                mouseLeft: this.left,
                anchorElement: this.props.anchorElement,
                position: this.props.position,
                target: this,
                syntheticEvent: null,
                nativeEvent: null
              };
              i = this.props.onPosition.call(void 0, r);
            } else
              i = this.position(e);
            e.style.left = i.left + "px", e.style.top = i.top + "px";
          },
          className: m(
            "k-animation-container",
            "k-animation-container-fixed",
            "k-animation-container-shown",
            this.props.className
          ),
          style: {
            zIndex: t,
            ...this.props.style
          },
          tabIndex: 0
        },
        /* @__PURE__ */ s.createElement("div", { className: "k-child-animation-container" }, /* @__PURE__ */ s.createElement(
          "div",
          {
            id: this.props.id,
            role: "tooltip",
            className: m(
              "k-tooltip",
              this.props.tooltipClassName
            ),
            style: { position: "relative", ...this.props.tooltipStyle }
          },
          /* @__PURE__ */ s.createElement("div", { className: "k-tooltip-content" }, this.props.content && /* @__PURE__ */ s.createElement(this.props.content, { title: this.state.title, target: this.state.targetElement }) || this.state.title),
          this.props.showCallout && /* @__PURE__ */ s.createElement(
            "div",
            {
              ref: (e) => {
                e && (e.className = this.calloutClassName(), this.props.position === "auto" && (this.left < window.screen.availWidth / 2 ? e.style.left = this.props.setCalloutOnPositionAuto || "25%" : e.style.left = this.props.setCalloutOnPositionAuto || "75%"));
              }
            }
          )
        ))
      ),
      this.props.appendTo ? this.props.appendTo : o.ownerDocument.body
    );
  }
  showToolTip(o) {
    clearTimeout(this.openTimeoutId), clearInterval(this.updateIntervalId), o.target.hasChildNodes() && o.target.childNodes.forEach((i) => {
      i.nodeName === "title" && (o.target.titleExpando = i.innerHTML, i.remove());
    });
    const t = this.props.targetElement || o.target;
    let e = this.getTitle(t);
    if (!e.title) {
      this.state.open && this.onClose(o);
      return;
    }
    e.element && (e.element.titleExpando = e.title, e.element.title = ""), this.willOpen = !0, this.props.openDelay ? this.openTimeoutId = window.setTimeout(
      () => {
        this.willOpen && this.setState({ targetElement: t, open: !0, title: e.title }, this.setUpdateInterval);
      },
      this.props.openDelay
    ) : this.setState({ targetElement: t, open: !0, title: e.title }, this.setUpdateInterval), this.state.title !== e.title && P(this.props.onOpen, o, this, void 0);
  }
  isVisible(o) {
    return !this.props.filter || this.props.filter(o);
  }
};
let T = A;
T.propTypes = {
  anchorElement: n.oneOf(["pointer", "target"]),
  content: n.func,
  filter: n.func,
  openDelay: n.number,
  position: n.oneOf(["right", "left", "top", "bottom", "auto"]),
  updateInterval: n.number
};
T.defaultProps = {
  anchorElement: "pointer",
  openDelay: 400,
  position: "auto",
  showCallout: !0,
  parentTitle: !1
};
T.contextType = k;
const d = s.forwardRef((o, t) => {
  const e = s.useRef(null), i = s.useRef(null);
  return s.useImperativeHandle(i, () => ({ props: o, element: e.current })), s.useImperativeHandle(t, () => i.current), /* @__PURE__ */ s.createElement(
    "div",
    {
      ref: e,
      className: m(
        "k-popover-actions",
        "k-actions",
        {
          [`k-actions-${o.alignment}`]: o.alignment,
          [`k-actions-${o.orientation}`]: o.orientation
        }
      )
    },
    o.children
  );
}), lt = {
  alignment: "stretched",
  orientation: "horizontal"
};
d.propTypes = {
  alignment: n.oneOf(["start", "center", "end", "stretched"]),
  orientation: n.oneOf(["horizontal", "vertical"]),
  children: n.oneOfType([
    n.element,
    n.node
  ])
};
d.defaultProps = lt;
d.displayName = "KendoReactPopoverActionsBar";
const at = 12e3, pt = 2e3, x = 15, ct = {
  top: "k-callout-s",
  left: "k-callout-e",
  bottom: "k-callout-n",
  right: "k-callout-w"
}, ut = {
  top: "k-callout-n",
  left: "k-callout-w",
  bottom: "k-callout-s",
  right: "k-callout-e"
}, ht = {
  top: { vertical: "bottom", horizontal: "center" },
  left: { vertical: "center", horizontal: "right" },
  bottom: { vertical: "top", horizontal: "center" },
  right: { vertical: "center", horizontal: "left" }
}, dt = {
  top: { vertical: "top", horizontal: "center" },
  left: { vertical: "center", horizontal: "left" },
  bottom: { vertical: "bottom", horizontal: "center" },
  right: { vertical: "center", horizontal: "right" }
}, ft = (o) => s.Children.toArray(o).filter((t) => t && t.type === d), mt = (o) => s.Children.toArray(o).filter((t) => t && t.type !== d), w = s.forwardRef((o, t) => {
  D(R);
  const {
    callout: e,
    position: i,
    title: r,
    children: a,
    show: M,
    anchor: z,
    appendTo: L,
    offset: U,
    animate: B,
    positionMode: S,
    scale: Z,
    popoverClass: c,
    className: _,
    id: F,
    style: K,
    collision: V,
    contentStyle: b,
    onPosition: v,
    onClose: g,
    onOpen: y
  } = o, [j, E] = s.useState(!1), I = i === "top" || i === "bottom", X = o.margin || {
    vertical: e && I ? x : 0,
    horizontal: e && !I ? x : 0
  }, H = ht[i], $ = dt[i], O = s.useContext(k), Y = O ? O + pt : at, h = s.useRef(null);
  s.useImperativeHandle(h, () => ({ props: o })), s.useImperativeHandle(t, () => h.current);
  const q = s.useCallback(
    (l) => {
      if (setTimeout(() => E(l.flipped)), v) {
        const W = { target: h.current, flipped: l.flipped, fitted: l.fitted };
        v.call(void 0, W);
      }
    },
    [v, E]
  ), G = s.useCallback(
    () => {
      if (y) {
        const l = { target: h.current };
        y.call(void 0, l);
      }
    },
    [y]
  ), J = s.useCallback(
    () => {
      if (g) {
        const l = { target: h.current };
        g.call(void 0, l);
      }
    },
    [g]
  ), f = { "k-popover": !0 };
  Array.isArray(c) ? c.forEach((l) => f[l] = !0) : typeof c == "object" ? Object.keys(c).forEach((l) => {
    f[l] = c[l];
  }) : c && (f[c] = !0);
  const Q = j ? ut[i] : ct[i], C = s.useMemo(
    () => /* @__PURE__ */ s.createElement(s.Fragment, null, r && /* @__PURE__ */ s.createElement("div", { className: "k-popover-header" }, r), /* @__PURE__ */ s.createElement("div", { className: "k-popover-body", style: b }, mt(a)), ft(a)),
    [a, b, r]
  );
  return /* @__PURE__ */ s.createElement(k.Provider, { value: Y }, /* @__PURE__ */ s.createElement(
    et,
    {
      id: F,
      role: "tooltip",
      animate: B,
      collision: V,
      anchor: z,
      offset: U,
      margin: X,
      popupAlign: H,
      anchorAlign: $,
      appendTo: L,
      show: M,
      scale: Z,
      positionMode: S,
      style: K,
      className: _,
      popupClass: f,
      onOpen: G,
      onClose: J,
      onPosition: q
    },
    e && i ? /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement("div", { className: m("k-popover-callout", Q) }), /* @__PURE__ */ s.createElement("div", { className: "k-popover-inner" }, C)) : C
  ));
}), vt = {
  callout: !0,
  position: "top",
  collision: {
    horizontal: "none",
    vertical: "none"
  }
};
w.propTypes = {
  callout: n.bool,
  title: n.node,
  position: n.oneOf(["top", "left", "bottom", "right"]),
  show: n.bool,
  animate: n.oneOfType([
    n.bool,
    n.shape({
      openDuration: n.number,
      closeDuration: n.number
    })
  ]),
  anchor: function(o) {
    const t = o.anchor;
    return t && typeof t.nodeType != "number" ? new Error(
      "Invalid prop `anchor` supplied to `Kendo React Popover`. Validation failed."
    ) : null;
  },
  appendTo: function(o) {
    const t = o.appendTo;
    return t && typeof t.nodeType != "number" ? new Error(
      "Invalid prop `appendTo` supplied to `Kendo React Popover`. Validation failed."
    ) : null;
  },
  positionMode: n.oneOf([
    "fixed",
    "absolute"
  ]),
  scale: n.number,
  offset: n.shape({
    left: n.number,
    top: n.number
  }),
  children: n.oneOfType([
    n.element,
    n.node
  ]),
  className: n.oneOfType([
    n.string,
    n.arrayOf(n.string),
    n.object
  ]),
  id: n.string,
  popoverClass: n.oneOfType([
    n.string,
    n.arrayOf(n.string),
    n.object
  ]),
  style: n.object,
  onClose: n.func,
  onPosition: n.func,
  onOpen: n.func
};
w.defaultProps = vt;
w.displayName = "KendoReactPopover";
export {
  w as Popover,
  d as PopoverActionsBar,
  T as Tooltip
};
